import { render } from "./FolderNavigation.vue?vue&type=template&id=2c47951a&scoped=true"
import script from "./FolderNavigation.vue?vue&type=script&lang=js"
export * from "./FolderNavigation.vue?vue&type=script&lang=js"

import "./FolderNavigation.vue?vue&type=style&index=0&id=2c47951a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c47951a"]])

export default __exports__